import { disableTabs, enableTabs } from './helpers/tabFocus';

const SELECTORS = {
    MODAL: '.js-modal',
    CLOSE: '.js-modal-close',
    TOGGLE: '.js-modal-hook',
};

const MODIFIER = 'modal--open';

class Modal {
    constructor({ modal, hook, cbOnOpen, cbOnClose }) {
        this.modal = modal;
        this.close = [...this.modal.querySelectorAll(SELECTORS.CLOSE)];
        this.isOpen = this.modal.classList.contains(MODIFIER);
        this.open = hook;
        this.cbOnOpen = cbOnOpen;
        this.cbOnClose = cbOnClose;
        this.initialized = false;

        this.hideModal = this.hideModal.bind(this);
        this.showModal = this.showModal.bind(this);
        this.init = this.init.bind(this);

        this.init();
        this.addEventListeners();
    }

    init() {
        if (!this.isOpen) {
            disableTabs(this.modal);
        }

        this.setAreaAttributes();
    }

    addEventListeners() {
        this.close.forEach((close) => {
            close.addEventListener('click', (e) => {
                e.preventDefault();

                if (this.isOpen) {
                    this.hideModal();
                }
            });
        });

        window.addEventListener('keyup', (e) => {
            e.preventDefault();

            if ((e.key === 'Esc' || e.key === 'Escape') && this.isOpen) {
                this.hideModal();
            }
        });
    }

    hideModal() {
        this.isOpen = false;
        this.modal.classList.remove(MODIFIER);
        disableTabs(this.modal);
        this.setAreaAttributes();

        if (this.initialized) {
            this.initialized = false;
        }

        if (this.cbOnClose) {
            this.cbOnClose();
        }
    }

    showModal() {
        this.isOpen = true;
        this.modal.classList.add(MODIFIER);
        enableTabs(this.modal);
        this.setAreaAttributes();

        if (!this.initialized) {
            this.initialized = true;
        }

        if (this.cbOnOpen) {
            this.cbOnOpen();
        }
    }

    setAreaAttributes() {
        this.close.forEach((close) => close.setAttribute('aria-expanded', this.isOpen));
        this.open.setAttribute('aria-expanded', this.isOpen);
        this.modal.setAttribute('aria-hidden', !this.isOpen);
    }
}

function initModals() {
    const modalHooks = [...document.querySelectorAll(SELECTORS.TOGGLE)];

    if (modalHooks) {
        modalHooks.forEach((hook) => {
            const target = document.querySelector(hook.dataset.target);
            const modal = new Modal({
                hook,
                modal: target,
            });

            hook.addEventListener('click', (e) => {
                e.preventDefault();

                if (!modal.isOpen) {
                    modal.showModal();
                } else {
                    modal.hideModal();
                }
            });
        });
    }
}

export { initModals, Modal };
